import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../utils/response-util.service';

@Injectable()
export class VersionHttpService {
  private pulse: string = this.environment.baseUrl + '/pulse';

  constructor(private http: HttpClient,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  getFrontendVersion(): Observable<Object> {
    return this.http.get('/assets/version.json')
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getBackendVersion(): Observable<Object> {
    return this.http.get(this.pulse)
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/version/service/version.http.service.ts